import findBySlug from "./find-by-slug";

const findSchoolLevel = (container, route) =>
  findBySlug(container?.schoolLevels, route.params.schoolLevelSlug);

export default function resolveRoutedSchoolLevel(route, { state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  // Once the container is loaded, we an determine if the school level slug
  // route parameter matches one of the defined school levels. However,
  // if there is no school level slug parameter, then we can only
  // return null and let the app auto-determine a fallback school level.
  if (!route.params?.schoolLevelSlug) {
    return null;
  }

  // If a school level slug route parameter is defined, use the parameter to match
  // one of the defined school levels. If none matches, fall back to an auto school level.
  return findSchoolLevel(state.container, route);
}
